import React from "react";
import InfiniteScroll from "react-infinite-scroller";
import { useDispatch, useSelector } from "react-redux";
// import APIs
import DesignApi from "../api/visitor/Design";

//import UIs
import Button from "@mui/material/Button";
// import CloseIcon from "@mui/icons-material/Close";
import FindReplaceIcon from "@mui/icons-material/FindReplace";
import CloseIcon from "@mui/icons-material/Cancel";
import DesignCard from "../ui/cards/DesignCard";
import { ErrorNotify } from "../ui/Toast";

//import skeletons
import DesignCardSkeleton, {
  SingleDesignCardSkeleton,
} from "../ui/skeletons/DesignCard";

//import modal
import SearchModal from "../ui/modals/Search";

import { setIsLoading, setMetaData } from "../redux/reducers/page";

const Search = () => {
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [designs, setDesigns] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [count, setCount] = React.useState(0);
  const [filters, setFilters] = React.useState([]);
  const [cat1, setCat1] = React.useState(null);
  const [cat2, setCat2] = React.useState(null);
  const [title, setTitle] = React.useState(null);
  const [id, setId] = React.useState(null);
  const [orderBy, setOrderBy] = React.useState(null);
  const [hasMore, setHasMore] = React.useState(true);
  const [searchModalOpen, setSearchModalOpen] = React.useState(true);
  const [cat2List, setCat2List] = React.useState(false);

  const pageSize = 10;
  // redux
  const dispatch = useDispatch();
  const { auth } = useSelector((state) => state.customerAuth);
  const { info } = useSelector((state) => state.visitor);
  const { rootDesignCats } = useSelector((state) => state.page);

  const deleteFilter = (item) => {
    if (item.type === "cat1") setCat1(null);
    if (item.type === "cat2") setCat2(null);
    if (item.type === "title") setTitle(null);
    if (item.type === "orderBy") setOrderBy(null);
    setCat2List(false);
    setFilters([
      ...new Set(
        filters.filter(function (e) {
          return e !== item;
        })
      ),
    ]);
  };
  // find Search designs
  const findDesigns = async () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    setIsLoaded(false);
    setHasMore(true);
    const result = await DesignApi(
      auth.token,
      info.token,
      cat1 ? cat1.id : null,
      cat2 ? cat2.id : null,
      title,
      id,
      0,
      pageSize,
      orderBy
    );

    if (result.status !== 200) {
      ErrorNotify(JSON.parse(result.response).error);
      return;
    }
    let lastestLoads = [];
    setDesigns(lastestLoads.concat(result.data.Designs));

    setCount(result.data.count);
    dispatch(setIsLoading(false));
    setPage(1);
    setIsLoaded(true);
  };
  const fetchData = async () => {
    if (page * pageSize > count) {
      setHasMore(false);
      return;
    }
    const result = await DesignApi(
      auth.token,
      info.token,
      cat1 ? cat1.id : null,
      cat2 ? cat2.id : null,
      title,
      id,
      page,
      pageSize,
      orderBy
    );
    setDesigns(designs.concat(result.data.Designs));
    setPage(page + 1);
  };

  React.useEffect(() => {
    dispatch(setIsLoading(true));
    dispatch(
      setMetaData({
        title: "میشرت : جستجو",
        description: "میشرت: جستجو",
      })
    );
    findDesigns();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);
  return (
    <div className="col-12 col-md-7  col-lg-6 col-xl-5  justify-content-center">
      <SearchModal
        items={{
          setCat1,
          cat1,
          setCat2,
          cat2,
          setTitle,
          setId,
          title,
          orderBy,
          setOrderBy,
          findDesigns,
          rootDesignCats,
          setFilters,
          cat2List,
          setCat2List,
        }}
        openModal={searchModalOpen}
        setOpenModal={setSearchModalOpen}
      />
      <div
        style={{
          position: "fixed",
          top: "70px",
          zIndex: "1000",
        }}
      >
        <Button
          style={{ margin: "3px" }}
          variant="contained"
          size="small"
          color="primary"
          onClick={() => {
            setSearchModalOpen(true);
            setCat2List(false);
          }}
          endIcon={<FindReplaceIcon />}
        >
          جستجوی طرح ها
        </Button>
        {filters.map((item, index) => {
          return (
            <Button
              style={{ margin: "3px" }}
              key={index}
              variant="contained"
              size="small"
              color="error"
              onClick={() => deleteFilter(item)}
              endIcon={<CloseIcon />}
            >
              {item.text}
            </Button>
          );
        })}
      </div>

      {isLoaded ? (
        <>
          <InfiniteScroll
            pageStart={0}
            loadMore={fetchData}
            hasMore={hasMore}
            loader={<SingleDesignCardSkeleton key={page} />}
          >
            {designs.map((design, index) => {
              return <DesignCard key={index} design={design} auth={auth} />;
            })}
          </InfiniteScroll>
        </>
      ) : (
        <DesignCardSkeleton />
      )}
    </div>
  );
};

export default Search;
